module.exports = __webpack_public_path__ + "static/assets/6700bbb3ddff3f5bd94ab24020f739da.png";